(function() {
    angular
        .module("customersModule")
        .controller("CustomersController", CustomersController)

    CustomersController.$inject = [
        "$rootScope",
        "$scope",
        "customersService",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function CustomersController(
        $rootScope,
        $scope,
        customersService,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        /**
            $rootScope variables
         **/
        $rootScope.title = "Customers | WANCO"

        /**
            Customers dataTable config
         **/
        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
                return customersService.getAllCustomersWithCPUPromise().then(function(data) {
                    return data
                })
            })
            .withPaginationType("simple")
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLengthMenu":     "View _MENU_",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"text-right"pfi><"clear">')
            .withOption("responsive", true)

        $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Name")
                .renderWith(function(data, type, full, meta) {
                    return '<a href="/customer-details/id/' + data.id + '">' + data.name + "</a>"
                }),
            DTColumnBuilder.newColumn("city").withTitle("City")
        ]
    }
})()
